var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_5671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 27.0417L13.3965 30.0965C13.6036 30.2142 13.8378 30.2761 14.076 30.2761C14.3142 30.2761 14.5484 30.2142 14.7555 30.0965L25.5951 23.8333M7.94922 22L13.3965 25.0548C13.6036 25.1725 13.8378 25.2344 14.076 25.2344C14.3142 25.2344 14.5484 25.1725 14.7555 25.0548L25.5951 18.7917M7.94922 16.9583L13.3965 20.0131C13.6036 20.1309 13.8378 20.1927 14.076 20.1927C14.3142 20.1927 14.5484 20.1309 14.7555 20.0131L25.5951 13.75",
    stroke: "#0796A7",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5957 8.25V35.75H9.0957V8.25H36.5957ZM38.1082 5.5H7.5832C7.255 5.5 6.94023 5.63038 6.70816 5.86246C6.47608 6.09453 6.3457 6.40929 6.3457 6.7375V37.2625C6.3457 37.5907 6.47608 37.9055 6.70816 38.1375C6.94023 38.3696 7.255 38.5 7.5832 38.5H38.1082C38.4364 38.5 38.7512 38.3696 38.9832 38.1375C39.2153 37.9055 39.3457 37.5907 39.3457 37.2625V6.7375C39.3457 6.40929 39.2153 6.09453 38.9832 5.86246C38.7512 5.63038 38.4364 5.5 38.1082 5.5Z",
    fill: "#0796A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_5671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.845703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadIcon6);
export default __webpack_public_path__ + "static/media/rad_icon6.e5800c08fa5e3d77280cf46538ed714d.svg";
export { ForwardRef as ReactComponent };